<script>
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'Story',
  data () {
    return {
      container: null,
      page: 1,
      isVisible: true,
    }
  },
  mixins: [
    platformDetect,
  ],
  components: {
    BaseLayout,
  },
  mounted () {
    var body = document.getElementById('app')
    body.style.overflow = 'hidden'
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer')
      temp[0].style.visibility = 'hidden'
      temp[0].style.position = 'fixed'
    }, 4000)
  },
  methods: {
    test () {
      // console.log('coucou')
      if (this.isVisible) {
        this.isVisible = false
      } else {
        this.isVisible = true
      }
    },
  },
}
</script>
<template lang="pug">
base-layout
  div.cd-transition-layer(v-bind:class="{ visible: isVisible }")
  div.bgblackintro
  div.backgroundtexture
  div.animatedgradient
  div.story
    div.logosection
      img.logo(src="~@/assets/The_Story_Button.png", width="200px")
      div.introsection Explore the background to Dreaming of a Jewish Christmas, including why many Jews celebrate the holiday with Chinese food, the history of Jews and Christmas, and a timeline of Jewish Christmas song writers and songs.
      hr.lignemenu.mt4

    div.contentsection
      div.menucontent.ttu
        div.menustyle2
          router-link(to='story/chow-mein') Why chow mein is the <br> chosen food
        div.menustyle2
          router-link(to='story/christmas') Can the jew keep christmas ?
        div.menustyle2
          router-link(to='story/timeline') A timeline of songs & songwriters
        div.menustyle2
          router-link(to='story/recipes') Recipes

</template>


<style scoped>

/*ANIMATION*/
.logo{
  -moz-animation: swing 2s 5s;
  -webkit-animation: swing 2s 5s;
  animation: swing 2s 5s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.backgroundtexture, .animatedgradient{
  -moz-animation: fadeIn 2;
  -webkit-animation: fadeIn 2s;
  animation: fadeIn 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}

.logosection{
  -moz-animation: fadeInDown 2s 5s;
  -webkit-animation: fadeInDown 2s 5s;
  animation: fadeInDown 2s 5s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.menucontent{
  -moz-animation: fadeInUp 2s 5s;
  -webkit-animation: fadeInUp 2s 5s;
  animation: fadeInUp 2s 5s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.lignemenu{
  -moz-animation: zoomIn 2s 5.5s;
  -webkit-animation: zoomIn 2s 5.5s;
  animation: zoomIn 2s 5.5s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.bgblackintro{
  position:fixed;
  height:100vh;
  width:100vw;
  background-color: black;
  -moz-animation: fadeOut 2s 4s;
  -webkit-animation: fadeOut 2s 4s;
  animation: fadeOut 2s 4s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.cd-transition-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  height: 100%;
  width: 100%;
  opacity: 0;
  /*visibility: hidden;
  overflow: hidden;*/
}
.cd-transition-layer, .bg-layer{
  position: absolute;
  left: 50%;
  top: 50%;
  height: calc(100vw * 0.5625);
  width: calc(100vw * 100);
  /*width: calc(39680px / 9vw);*/
  background: url("~@/assets/transitions/montage_story_transition.jpg") no-repeat 0 0;
  background-size: 100% 100%;
}
@keyframes cd-sequence {
  0% {
    transform: translateY(-50%) translateX(-0.50%);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    transform: translateY(-50%) translateX(-100.50%);
    opacity: 0;
  }
}
.cd-transition-layer.visible {
  /*animation: cd-sequence 2.15s steps(62);*/
  animation: cd-sequence 3.7523s steps(100);
  animation-fill-mode: normal;
  /*animation-direction: reverse;*/
  /*animation-timing-function: ease-in;*/
  animation-iteration-count: 1;
  visibility: visible;
}
/*ANIMATIONS END*/
.animatedgradient{
background: linear-gradient(233deg, #4f0051, #8f0000, #e30000, #ff0000, #ff0000, #fff);
background-size: 1200% 1200%;
min-width:100vw;
width:100%;
opacity:0.5;
min-height:100vh;
height:100%;
z-index:-10;
position:absolute;
mix-blend-mode:hard-light;
-webkit-animation: AnimationName 20s ease infinite;
-moz-animation: AnimationName 20s ease infinite;
-o-animation: AnimationName 20s ease infinite;
animation: AnimationName 20s ease infinite;
}
@-webkit-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@-o-keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@keyframes AnimationName {
    0%{background-position:0% 46%}
    50%{background-position:100% 55%}
    100%{background-position:0% 46%}
}
@media only screen and (min-width: 320px){
  .backgroundblack{
    background-color: black;
    height: 100vh;
    width:100vw;
    z-index:-11;
    position:fixed;
  }
  .backgroundtexture{
  /*background-image: url("~@/assets/imgs_bg/testbg_uncolored.png");*/
  background-image: url("~@/assets/imgs_bg/fond9.jpg");

  background-size: cover;
  background-position: center;
  height: 100%;
  min-height: 100vh;
  width:100vw;
  z-index:-11;
  position:absolute;
  }
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    /*bottom: 5%;*/
    right: 10%;
    bottom:0%;
    color: white;
    background-color: red;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 0%;
    left: 10%;
    color: white;
    background-color: red;
  }
  .lignemenu{
    width:60%;
    max-width:500px;
    border-color: white;
    margin-bottom:0px !important;
    overflow: visible; /* For IE */
    height: 30px;
    border-style: solid;
    border-width: 1px 0 0 0;
    border-radius: 20px;
  }
  .lignemenu:after{
    display: block;
    content: "";
    height: 30px;
    margin-top: -31px;
    border-style: solid;
    border-color: white;
    border-width: 0 0 1px 0;
    border-radius: 20px;
  }
  .introsection{
    color:white;
    width:85%;
    max-width:400px;
    opacity: 1;
    text-align: center;
    margin: 0 auto;
    line-height: 22px;
    font-size: 18px;
    font-style:italic;
    font-family: Crimson Text;
    /*font-family: BritannicBold;*/
  }
  .story{
    height:100%;
    & .logosection{
      padding-top:12%;
    }
    & .menucontent{
      width: 100%;
      & .menustyle{
        width: 280px;
        border-style: solid;
        border-width: 0 0 1px 0;
        text-align: left !important;
        border-color: red;
        padding:10px;
        font-family:Marketdeco;
        color: red;
        font-size: 20px;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      & .menustyle2{
        width:200px;
        margin: 20px auto 20px;
        /*line-height:24px;*/
        font-size:24px;
        /*font-family:Marketdeco;*/
        font-family:Barlow Condensed;
        font-weight: 400;
        /*text-transform: uppercase;*/
      }
      & a{
        color:white;
      }
    }
  }
  /* .story:before{
  content: " ";
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border: 4px double red;
  } */
}
@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
.lignemenu{
  display:none!important;
}
.story{
  & .titrecontent{
    font-family:Marketdeco;
    color: red;
    font-size: 20px;
    margin-bottom: 30px;
    margin-top: 50px;
    & span{
      border-style: solid;
      border-width: 3px 0 3px 0;
      border-color: red;
      padding: 5px 10px 5px 10px;
    }
  }
  & .introsection{
    color:white;
    width:100%;
    text-align: center;
    margin: 0 auto;
    line-height: 18px;
    font-size: 16px;
    /*font-weight: bold;*/
    /*font-family: BritannicBold;*/
  }
  & .logosection{
    float:left;
    width: 45%;
    padding-top: 7%;
    padding-left:10%;
    /*height: 100vh;*/
  }
  & .contentsection{
    float:left;
    width: 50%;
    margin-top: 5%;
    margin-left:5%;
  }
}
}
@media only screen and (min-width: 768px){
  .cd-transition-layer, .bg-layer{
    filter:blur(1px);
  }
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .story{
    & .logosection{
      padding-top: 18%;
    }
    & .contentsection{
      & .titresection{
        font-family:Marketdeco;
        color: red;
        font-size: 30px;
        margin-bottom: 50px;
        margin-top: 50px;
        & span{
          border-style: solid;
          border-width: 3px 0 3px 0;
          border-color: red;
          padding: 5px 10px 5px 10px;
        }
      }
      & .menucontent{
        width: 100%;
        & .menustyle2{
          width:300px;
          margin: 40px auto 20px;
          /*line-height:24px;*/
          font-size:26px;
          /*font-family:Marketdeco;*/
          /*font-weight: 400;*/
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (orientation:landscape) {
  .cd-transition-layer, .bg-layer{
    filter:blur(1px);
  }
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .story{
    & .logosection{
      padding-top: 10%;
    }
  }
}
@media only screen and (min-width: 961px){

  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 50%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 50%;
    left: 10%;
  }
  .story{
    & .logosection{
      padding-top: 10%;
    }
  }
}
@media only screen and (min-width: 1200px){
  .cd-transition-layer, .bg-layer{
    filter:blur(2px);
  }
}
</style>



// WEBPACK FOOTER //
// Story.vue?fdf9b074